import React from 'react';
import PropTypes from 'prop-types';

const ShareIos = ({ fill, className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16.146 20.364"
    className={className}
  >
    <path
      d="M10.318-4.087a.925.925,0,0,0,.923-.905V-13.7l-.079-1.292.5.668L12.814-13.1a.819.819,0,0,0,.6.264.784.784,0,0,0,.809-.782.792.792,0,0,0-.246-.571l-2.936-2.821a.984.984,0,0,0-.721-.316.966.966,0,0,0-.712.316L6.671-14.194a.768.768,0,0,0-.255.571.782.782,0,0,0,.8.782.858.858,0,0,0,.615-.264l1.143-1.222.51-.668L9.4-13.7v8.71A.917.917,0,0,0,10.318-4.087ZM5.238,3.032H15.39a2.675,2.675,0,0,0,3-2.979V-8.481a2.675,2.675,0,0,0-3-2.979H13.078v2.013h2.127a1.053,1.053,0,0,1,1.178,1.187v8.1A1.05,1.05,0,0,1,15.205,1.02H5.423A1.041,1.041,0,0,1,4.254-.158v-8.1A1.043,1.043,0,0,1,5.423-9.448H7.585v-2.013H5.238a2.679,2.679,0,0,0-3,2.979V.053A2.679,2.679,0,0,0,5.238,3.032Z"
      transform="translate(-2.241 17.332)"
      fill={fill}
    />
  </svg>
);

ShareIos.propTypes = {
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default ShareIos;
